import React from "react"
import { NewsletterSignupBoxed } from "./newsletter-signup-boxed"
import { XmarkIcon } from "components/page-components/Icons/small"

export const ExitIntentSignupModal = ({
  ressort,
  exit_intent_modal_open,
  close_exit_intent_modal,
}) => {
  return (
    <div
      data-nosnippet
      className={`modal${exit_intent_modal_open ? " is-active" : ""}`}
    >
      <div
        className="modal-background"
        onClick={close_exit_intent_modal}
        role="button"
        tabIndex="-1"
        onKeyDown={() => {}}
        aria-label="Close exit_intent Modal"
      ></div>
      <div className="modal-content" style={{ maxWidth: 765 }}>
        <button
          className="button is-tertiary is-exit"
          style={{
            width: 48,
            height: 48,
            maxWidth: 48,
            maxHeight: 48,
            borderRadius: "50%",
            position: "absolute",
            right: 0,
            top: 0,
          }}
          onClick={close_exit_intent_modal}
        >
          <XmarkIcon {...{ color: "#034055", strokeWidth: "6" }} />
        </button>
        <div style={{ padding: 24 }}>
          <NewsletterSignupBoxed
            {...{ modal: true, ressort, close_exit_intent_modal }}
          />
        </div>
      </div>
    </div>
  )
}
